import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/context/AuthContext";
import { Loader2, MailCheck, ArrowLeft, ShieldCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Errore, riprova.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-border p-8" data-testid="forgot-password-page">
        <div className="w-10 h-10 bg-primary flex items-center justify-center"><ShieldCheck className="w-5 h-5 text-primary-foreground" /></div>
        <h1 className="font-heading font-black text-2xl tracking-tighter mt-4">Password dimenticata?</h1>
        {!sent ? (
          <>
            <p className="text-sm text-muted-foreground mt-2">Inserisci la tua email: ti invieremo un link per reimpostare la password (valido 1 ora).</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email" className="data-label">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 rounded-none" placeholder="nome@azienda.com" />
              </div>
              {error && <div data-testid="forgot-error" className="text-sm text-destructive border border-destructive/30 bg-destructive/5 px-3 py-2">{error}</div>}
              <Button type="submit" data-testid="forgot-submit-btn" disabled={loading} className="w-full rounded-none font-medium">
                {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Invia link di reset
              </Button>
            </form>
          </>
        ) : (
          <div className="mt-4" data-testid="forgot-success">
            <div className="flex items-center gap-2 text-emerald-700 font-medium text-sm"><MailCheck className="w-4 h-4" /> Richiesta inviata</div>
            <p className="text-sm text-muted-foreground mt-2">Se l'email <span className="font-medium text-foreground">{email}</span> è registrata riceverai a breve un link per reimpostare la password. Controlla anche lo spam.</p>
          </div>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-primary hover:underline" data-testid="back-to-login-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna al login
        </Link>
      </div>
    </div>
  );
}
